// assets
import { IconFolder } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| PROJECTS MENU ITEM ||============================== //

const icons = {
  IconFolder
};

const projects: NavItemType = {
  id: 'projects',
  title: 'projects',
  icon: icons.IconFolder,
  type: 'group',
  url: '/project-agents'
};

export default projects;
